import type { XY } from "../xy";
import { TextPopupEffect } from "./textPopupEffect";

// "Recharging" popup for a Rechargeable weapon fired while cooling down.
export class WeaponRechargePopupEffect extends TextPopupEffect {
	static key = "WeaponRechargePopupEffect";

	constructor(xy: XY) {
		super(xy, "popup_recharging");
	}
}
